import styled from "styled-components";

import { StyledSignIn } from "@pages/SignIn/SignIn.styled";

import { rem } from "@styles/Utilities.styled";


export const StyledRegister = styled(StyledSignIn)`
  .content {
    min-height: ${rem(300)};
  }

  .form {
    flex-grow: 1;
  }
`;
